export const ANALYTICS_RANGE_STORAGE_KEY = 'velox-admin-analytics-range';

export function readStoredAnalyticsRange() {
  try {
    const raw = sessionStorage.getItem(ANALYTICS_RANGE_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    const preset = parsed.preset == null ? null : String(parsed.preset);
    const start = typeof parsed.start === 'string' ? parsed.start : '';
    const end = typeof parsed.end === 'string' ? parsed.end : '';
    return { preset, start, end };
  } catch {
    return null;
  }
}

export function writeStoredAnalyticsRange(next) {
  try {
    sessionStorage.setItem(ANALYTICS_RANGE_STORAGE_KEY, JSON.stringify(next || {}));
  } catch {
    // Private mode / quota — range still works for this page instance.
  }
}

export function clearStoredAnalyticsRange() {
  try {
    sessionStorage.removeItem(ANALYTICS_RANGE_STORAGE_KEY);
  } catch {
    // ignore
  }
}
